export default __webpack_public_path__ + "static/media/anxiety.27cd9884.jpg";